import classNames from 'clsx';
import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import Link from '@swf/components/Link/Link';
import { UserClubRole } from '@swf/core/types/Poker';
import type { HgClubInfo } from '@swf/generated/types/api/v0/SwHomeGames';
import { useGetContentRoutes, useHomeGamesWidget } from '@swf/poker';

import styles from './SidebarNav.scss';
import ClubItem from './SidebarNavClubItem';

const filterClubs = ({ roleForUser }: HgClubInfo) =>
  roleForUser !== UserClubRole.Confirmation && roleForUser !== UserClubRole.Suspended;

const SidebarNav = () => {
  const { widgetSelect } = useHomeGamesWidget();
  const clubs = useSelector(widgetSelect.clubs);
  const { clubsPath } = useGetContentRoutes();

  return (
    <div className={styles.container}>
      <ul className={styles.nav}>
        <li className={classNames(styles.navItem, styles.active)}>
          <Link href={clubsPath}>Home Games</Link>
        </li>
        <li>
          {!isEmpty(clubs) && (
            <ul className={styles.subNav}>
              {clubs.filter(filterClubs).map((club) => (
                <li key={club.clubId} className={styles.subNavItem}>
                  <ClubItem club={club} clubsPath={clubsPath} />
                </li>
              ))}
            </ul>
          )}
        </li>
      </ul>
    </div>
  );
};

export default SidebarNav;
